import React from 'react';
import styled from 'styled-components';

const PrivacyPolicy = () => {
  return (
    <Wrapper>
      <div className="content-box">
        <h2>Privacy Policy</h2>

        <section>
          <p>
            At Bakpoket ("we," "us," or "our"), we are committed to protecting your privacy. This Privacy
            Policy explains how we collect, use, disclose, and safeguard your personal information when
            you visit our website, <a href="https://bakpoket.com/" target="_blank" rel="noopener noreferrer">bakpoket.com</a>, or use our services.
            By using the Website, you agree to the practices described in this Privacy Policy. If you do not
            agree, please do not use the Website.
          </p>
        </section>

        <section>
          <h4>1. Information We Collect</h4>
          <p>We may collect the following types of information:</p>
          <ul>
            <li><strong>Personal Information:</strong> Your name, email address, or other details you provide when creating an account, contacting us, or using our services.</li>
            <li><strong>Usage Data:</strong> Information such as your IP address, browser type, pages visited, time spent, and referring URLs.</li>
            <li><strong>Cookies and Tracking:</strong> We use cookies and similar tools to enhance experience, track behavior, and personalize content.</li>
          </ul>
        </section>

        <section>
          <h4>2. How We Use Your Information</h4>
          <p>We may use your information for the following purposes:</p>
          <ul>
            <li>To operate and maintain the Website.</li>
            <li>To provide and improve our services.</li>
            <li>To respond to your inquiries or provide customer support.</li>
            <li>To send updates, newsletters, or promotional content (you can opt out anytime).</li>
            <li>To analyze Website usage and improve content and services.</li>
            <li>To comply with legal obligations or protect our rights.</li>
          </ul>
        </section>

        <section>
          <h4>3. How We Share Your Information</h4>
          <p>We do not sell or rent your personal data. However, we may share it in these cases:</p>
          <ul>
            <li><strong>Service Providers:</strong> With trusted partners helping operate the Website (e.g., hosting, analytics, payment).</li>
            <li><strong>Legal Requirements:</strong> If legally required (e.g., subpoena, court order).</li>
            <li><strong>Business Transfers:</strong> In a merger, acquisition, or asset sale scenario.</li>
          </ul>
        </section>

        <section>
          <h4>4. Cookies and Tracking Technologies</h4>
          <p>We use cookies to improve your experience. You can disable cookies in your browser, but some site features may not work properly.</p>
        </section>

        <section>
          <h4>5. Your Choices</h4>
          <p>You have the right to:</p>
          <ul>
            <li><strong>Access & Update:</strong> Access/update your info via account or by contacting us.</li>
            <li><strong>Opt-Out:</strong> Unsubscribe from marketing emails anytime.</li>
            <li><strong>Cookies:</strong> Control cookie usage via browser settings.</li>
          </ul>
        </section>

        <section>
          <h4>6. Data Security</h4>
          <p>We use reasonable measures to protect your data, but no system is 100% secure.</p>
        </section>

        <section>
          <h4>7. Third-Party Links</h4>
          <p>Our site may contain links to third-party websites. We are not responsible for their content or privacy practices. Please review their policies.</p>
        </section>

        <section>
          <h4>8. Children's Privacy</h4>
          <p>Our services are not intended for children under 13. If we discover such data, we will delete it promptly.</p>
        </section>

        <section>
          <h4>9. International Users</h4>
          <p>The Website is operated from [Insert Jurisdiction, e.g., India]. If you access it from another region, your data may be processed here.</p>
        </section>
      </div>
    </Wrapper>
  );
};

const Wrapper = styled.section`
  background-color: #e6e6e6;
  padding: 40px 16px;
  display: flex;
  justify-content: center;

  .content-box {
    width: 100%;
    max-width: 1200px;
    background-color: #ffffff;
    padding: 40px;
    border-radius: 10px;
    color: #333;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    line-height: 1.7;
    font-size: 1rem;
  }

  h2 {
    margin-bottom: 30px;
    font-size: 2rem;
    font-weight: 600;
    text-align: center;
    color: #2a4157;
  }

  h4 {
    margin-top: 30px;
    margin-bottom: 10px;
    color: #ef4766;
    font-size: 1.3rem;
  }

  ul {
    margin-left: 20px;
    padding-left: 20px;
    list-style: disc;
  }

  li {
    margin-bottom: 10px;
  }

  a {
    color: #ef4766;
    text-decoration: none;
  }

  @media (max-width: 768px) {
    .content-box {
      padding: 25px;
      font-size: 0.95rem;
    }

    h2 {
      font-size: 1.6rem;
    }

    h4 {
      font-size: 1.1rem;
    }
  }

  @media (max-width: 480px) {
    padding: 10px 16px 40px;

    .content-box {
      padding: 20px;
      font-size: 0.9rem;
    }

    h2 {
      font-size: 1.4rem;
    }

    h4 {
      font-size: 1rem;
    }
  }
`;

export default PrivacyPolicy;
